import { render, staticRenderFns } from "./UnEdit.vue?vue&type=template&id=0c19dffa&scoped=true&"
import script from "./UnEdit.vue?vue&type=script&lang=js&"
export * from "./UnEdit.vue?vue&type=script&lang=js&"
import style0 from "./UnEdit.vue?vue&type=style&index=0&id=0c19dffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19dffa",
  null
  
)

export default component.exports